import { getSectionAdapter } from "../utils/sectionRegistry";

import "../styles/section-styles.css";
import "./adapters/encabezado";
import "./adapters/portada";
import "./adapters/franja";
import "./adapters/texto";
import "./adapters/division";
import "./adapters/filasDivididas";
import "./adapters/tarjetasImagen";
import "./adapters/lineaTiempo";
import "./adapters/acordeon";
import "./adapters/tarjetasAccion";
import "./adapters/carrusel";
import "./adapters/bloqueComercial";

const PageSectionRenderer = ({ section, index }) => {
  if (!section?.type) return null;
  const adapter = getSectionAdapter(section.type);
  return adapter ? adapter.render(section, index) : null;
};

export default PageSectionRenderer;
